var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThunderLogo = function SvgThunderLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 6.58c.188.2.224.421.11.662L5.5 24.624c-.136.25-.354.376-.656.376-.042 0-.115-.01-.219-.03a.664.664 0 0 1-.398-.286.551.551 0 0 1-.07-.45l3.077-12.14-6.342 1.518a.865.865 0 0 1-.188.015.743.743 0 0 1-.484-.165.549.549 0 0 1-.203-.586L3.157.48a.644.644 0 0 1 .25-.346A.728.728 0 0 1 3.844 0h5.124c.197 0 .364.063.5.188A.585.585 0 0 1 9.67.63c0 .08-.026.17-.078.27l-2.67 6.957 6.185-1.473a.886.886 0 0 1 .187-.03c.198 0 .375.075.531.226Z",
    fill: "#F36F40",
    fillRule: "nonzero"
  })));
};
export default SvgThunderLogo;